import { getElementXPath, BatchSpanProcessor, WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";

const exporter = new OTLPTraceExporter({
  url: "https://f122024.ddns.net:3201/custom_telemetry/otel",
});

const provider = new WebTracerProvider({
  spanProcessors: [
    //new SimpleSpanProcessor(new ConsoleSpanExporter())
    new BatchSpanProcessor(exporter),
  ],
});

provider.register({
  // Changing default contextManager to use ZoneContextManager - supports asynchronous operations - optional
  contextManager: new ZoneContextManager(),
});

const tracer = provider.getTracer("www.limacorpconsultants.com", "0.0.1");

let myPublicIpAddress = "";

const publicIpSpan = tracer.startSpan("public-ip");
fetch("https://api.ipify.org/?format=json")
  .then((response) => response.json())
  .then((jsonResp) => {
    myPublicIpAddress = jsonResp.ip;

    publicIpSpan.setAttribute("myPublicIpAddress", myPublicIpAddress);
    publicIpSpan.end();
  })
  .catch((error) => {
    myPublicIpAddress = error?.toString() || "Could not contact: https://api.ipify.org";

    publicIpSpan.setAttribute("error", error);
    publicIpSpan.end();
  });

const getBrowserInfo = () => ({
  navigatorPresent: !!navigator,
  userAgent: navigator?.userAgent || "",
  location: window.location.href,
  myPublicIpAddress,
});

const pageLoadSpan = tracer.startSpan("page-load");
window.addEventListener("load", () => {
  pageLoadSpan.setAttributes(getBrowserInfo());
  pageLoadSpan.end(); // End the span when the page finishes loading
});

document.querySelectorAll(".btn").forEach((btn) => {
  btn.addEventListener("click", (event) => {
    const target: any = event.target;
    tracer
      .startSpan("button-click", {
        attributes: {
          ...getBrowserInfo(),
          xpath: getElementXPath(event.target),
          innerHTML: target.innerHTML,
        },
        links: [{ context: pageLoadSpan.spanContext() }],
      })
      .end();
  });
});

document.querySelectorAll(".navbar-nav a").forEach((a) => {
  a.addEventListener("click", (event) => {
    const target: any = event.target;
    tracer
      .startSpan("navbar-nav-click", {
        attributes: {
          ...getBrowserInfo(),
          xpath: getElementXPath(event.target),
          innerHTML: target.innerHTML,
        },
        links: [{ context: pageLoadSpan.spanContext() }],
      })
      .end();
  });
});
